
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsAdvPromoHdActDialog extends Serenity.EntityDialog<PsAdvPromoHdActRow, any> {
        protected getFormKey() { return PsAdvPromoHdActForm.formKey; }
        protected getIdProperty() { return PsAdvPromoHdActRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoHdActRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoHdActRow.nameProperty; }
        protected getService() { return PsAdvPromoHdActService.baseUrl; }
        protected getDeletePermission() { return PsAdvPromoHdActRow.deletePermission; }
        protected getInsertPermission() { return PsAdvPromoHdActRow.insertPermission; }
        protected getUpdatePermission() { return PsAdvPromoHdActRow.updatePermission; }

        protected form = new PsAdvPromoHdActForm(this.idPrefix);

        
        
       
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            
            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active",
                    hint: "Active [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        Q.confirm(
                           '  ยืนยันการเปิดใช้งาน',
                            () => {
                                this.form.PromoStatus.value = "1";
                                this.form.PromoStatus.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "InActive",
                hint: "ยกเลิก Active",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-times-circle text-red",
                
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการเปิดใช้งานโปรโมชั่นนี้ "
                        ,
                        () => {
                            this.form.PromoStatus.value = "0";
                            this.form.PromoStatus.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            
            this.toolbar.findButton('delete-button').hide();
            this.toolbar.findButton('button-apply').hide();
            var date = $.datepicker.formatDate('yymmdd', new Date());
            var effdate = this.entity.EndPromoDate
            var a = effdate.split('T')[0];
            var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]
            //Q.confirm(effectdate + date, () => { });
            if (effectdate < date) {
            // if (this.entity.PromoApproveFg == 1) {
                this.toolbar.findButton('button-save-approve').hide();
                
                this.toolbar.findButton('button-save-cancle').hide();
            
            }else{
            // if (this.entity.PromoApproveFg == 1) {
                if (this.entity.PromoStatus == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    // this.toolbar.findButton('button-save-cancle').hide();
                    // this.toolbar.findButton('button-save-reject').hide();
                } else {
                    // this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();

                }
            }
        }

    }
}